import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=1233a6fd&scoped=true"
var script = {}
import style0 from "./faq.vue?vue&type=style&index=0&id=1233a6fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1233a6fd",
  null
  
)

export default component.exports